<template>
  <div class="reportForm">
    <div class="leftNav">
      <div class="title">交班报表</div>
      <div class="nav">
        <div :class="navCurrent == i ? 'navcheck' : ''" v-for="(v, i) in nav" :key="i" class="navItem" @click="checkNav(v, i)">
          {{ v }}
        </div>
      </div>
    </div>
    <div class="rightMain">
      <template v-if="navCurrent == 0">
        <div class="rightTitle">
          <headerCatering key="1"></headerCatering>
        </div>
        <el-card class="rightContent" ref="tablePrint">
          <shiftBusiness></shiftBusiness>
        </el-card>
      </template>
      <template v-if="navCurrent == 1">
        <div class="rightTitle">
          <headerCatering key="2" :isExport="false"></headerCatering>
        </div>
        <el-card class="rightContent" ref="tablePrint">
          <longitudinal></longitudinal>
        </el-card>
      </template>
      <template v-if="navCurrent == 2">
        <el-row>
          <headerCatering key="3"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <menuConsumption></menuConsumption>
        </el-card>
      </template>
      <template v-if="navCurrent == 3">
        <el-row>
          <headerCatering key="4" :isFood="true"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <salesList></salesList>
        </el-card>
      </template>
      <template v-if="navCurrent == 4">
        <el-row>
          <headerCatering key="5" :isDay="false" :isdel="false"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <punchingMenu></punchingMenu>
        </el-card>
      </template>
      <template v-if="navCurrent == 5">
        <el-row>
          <headerCatering key="6" :isdel="false" :isDay="false"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <posDayliReport></posDayliReport>
        </el-card>
      </template>
      <template v-if="navCurrent == 6">
        <el-row>
          <headerCatering key="7" :isDay="false"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <operatingIncome></operatingIncome>
        </el-card>
      </template>
      <template v-if="navCurrent == 7">
        <el-row>
          <headerCatering key="8"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <posSalesDetailsList></posSalesDetailsList>
        </el-card>
      </template>
      <template v-if="navCurrent == 8">
        <el-row>
          <headerCatering key="9" :isDay="false" :isSales="true"></headerCatering>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <salesPerson></salesPerson>
        </el-card>
      </template>
      <template v-if="navCurrent == 9">
        <el-row>
          <buffet-table-header key="10" :isDay="false" :isSales="true"></buffet-table-header>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <buffet></buffet>
        </el-card>
      </template>
      <template v-if="navCurrent == 10">
        <el-row>
          <company-table-header key="10" :isDay="false" :isSales="true"></company-table-header>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <company-summary></company-summary>
        </el-card>
      </template>
      <template v-if="navCurrent == 11">
        <el-row>
          <company-table-header key="10" :isDay="false" :isSales="true"></company-table-header>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <company-details></company-details>
        </el-card>
      </template>
      <template v-if="navCurrent == 12">
        <el-row>
          <timeWiteOff-header key="10" :isDay="false" :isSales="true"></timeWiteOff-header>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <timeWite-off></timeWite-off>
        </el-card>
      </template>
      <template v-if="navCurrent == 13">
        <el-row>
          <custWiteOffHeader key="10" :isDay="false" :isSales="true"></custWiteOffHeader>
        </el-row>
        <el-card class="print" ref="tablePrint">
          <custWiteOff></custWiteOff>
        </el-card>
      </template>
    </div>

    <!-- <div class="rightMain">
      <div class="rightTitle">
        <div class="Tool">
          <div class="titleItem" v-for="(v,i) in titleList" :key="i" :class="currentTitle == i ? 'titleItemCurrent' : '' " @click="todayOrhistory(v,i)"> {{v}} </div>

          <div >
            <el-date-picker :picker-options="currentTitle== 1?pickerOptions0:''" v-model="value1" value-format="yyyy-MM-dd" type="date" style="width:170px" placeholder="选择日期">
            </el-date-picker>
            <span style="margin:0 10px">至</span>
            <el-date-picker :picker-options="pickerOptions0" v-model="value2" type="date" value-format="yyyy-MM-dd" style="width:170px" placeholder="选择日期">
            </el-date-picker>
          </div>
          <div style="margin:0 10px 0 10px">
            <el-select v-model="bcvalue" placeholder="班次" style="width:150px">
              <el-option v-for="item in shiftCodeList" :key="item.name" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div style="margin:0 10px 0 0">
            <el-select v-model="ghvalue" placeholder="工号" style="width:150px">
              <el-option v-for="item in ghvalueList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="margin:0 10px 0 0">
            <el-select v-model="yydvalue" placeholder="营业点" style="width:150px">
              <el-option v-for="item in yydvalueList" :key="item.description" :label="item.description" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="FunctionalityBtn">
          <div class="feffBtn" @click="searchData">查询</div>
          <div class="blueBtn" @click="printClick">打印</div>
          <div class="blueBtn">导出</div>
        </div>
      </div>
      <div class="rightContent">
        <business v-if="navCurrent == 0" :reportDateTotal="reportDateTotal" :payTypeTotalSum="payTypeTotalSum" :payTypeTotal="payTypeTotal" :reportDateTotalSum="reportDateTotalSum" :collectionTabelTitel="collectionTabelTitel" :unCollectionAndHouse="unCollectionAndHouse" :handoverSalesTotal="handoverSalesTotal" :salesTabelTitel="salesTabelTitel" :statisticsData="statisticsData" :statisticsSum="statisticsSum" :sumsCollection="sumsCollection" :sumsSalesTotal="sumsSalesTotal" :listQuery="listQuery" :exportShow="true"></business>



        <salesList v-else-if="navCurrent == 2" :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList" :sumsTotal="sumsTotal"> </salesList>

        <dishSales v-else-if="navCurrent == 3" :listQuery="listQuery" :exportShow="true" :sumsTotal="cpTotal" :tabelList="cpList"> </dishSales>
      </div>
    </div> -->
  </div>
</template>

<script>
// import salesList from './components/salesList.vue'
import business from './components/business.vue';
import dishSales from './components/dishSales.vue';

import headerCatering from './headerCatering';
import shiftBusiness from './shiftBusiness';
import menuConsumption from './menuConsumption';
import salesList from './salesList';
import punchingMenu from './punchingMenu';
import longitudinal from './longitudinal';
import posDayliReport from './posDayliReport';
import operatingIncome from './operatingIncome';
import posSalesDetailsList from './posSalesDetailsList';
import salesPerson from './salesPerson.vue';
import SalesList from './salesList.vue';
import buffet from './buffet.vue';
import buffetTableHeader from './buffetTableHeader.vue';
import companyTableHeader from './companyTableHeader.vue';
import companySummary from './companySummary.vue';
import companyDetails from './companyDetails.vue';
import timeWiteOffHeader from './timeWiteOffHeader.vue';
import timeWiteOff from './timeWiteOff.vue';
import custWiteOffHeader from './custWiteOffHeader.vue';
import custWiteOff from './custWiteOff.vue';

export default {
  components: {
    salesList,
    business,
    dishSales,
    headerCatering,
    shiftBusiness,
    menuConsumption,
    punchingMenu,
    longitudinal,
    posDayliReport,
    operatingIncome,
    posSalesDetailsList,
    SalesList,
    salesPerson,
    buffet,
    buffetTableHeader,
    companyTableHeader,
    companySummary,
    companyDetails,
    timeWiteOffHeader,
    timeWiteOff,
    custWiteOffHeader,
    custWiteOff,
  },
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      listQuery: {},
      tabelList: [{}, {}],
      nav: [
        '营业点交班表横向',
        '营业点交班表纵向',
        '餐单消费明细表',
        '菜品销售榜',
        '冲退菜一览表',
        '餐饮营业日报',
        '餐饮收入情况统计日报',
        '餐饮部销售明细',
        '餐饮销售员业绩统计报表',
        '自助核销统计报表',
        '单位核销统计汇总',
        '单位核销统计明细',
        '时段单位核销统计',
        '人员核销统计',
      ],
      titleList: ['本日', '历史'],
      currentTitle: 0,
      navCurrent: 0,
      value1: '',
      value2: '',
      ghvalue: '',
      ghvalueList: [],
      bcvalue: '',
      bcvalueList: [],
      timevalue1: '',
      timevalue2: '',
      yydvalue: '',
      yydvalueList: [],
      options: [
        {
          value: '选项1',
        },
      ],
      shiftCodeList: [
        {
          name: '无',
          code: '0',
        },
        {
          name: '早班',
          code: '1',
        },
        {
          name: '中班',
          code: '2',
        },
        {
          name: '晚班',
          code: '3',
        },
        {
          name: '夜班',
          code: '4',
        },
      ],
      tabelTitel: [],
      tabelList: [],
      listShift: [
        {
          code: 'order_num',
          chinese_desc: '单号',
        },
        {
          code: 'people_count',
          chinese_desc: '人数',
        },
        {
          code: 'avgPeoplePrice',
          chinese_desc: '人均',
        },
      ],
      listPush: [
        {
          code: 'tax',
          chinese_desc: '税',
        },
        {
          code: 'discount',
          chinese_desc: '折扣',
        },
        {
          code: 'server_price',
          chinese_desc: '服务费',
        },
        {
          code: 'unPayPrice',
          chinese_desc: '挂单/未结',
        },
        {
          code: 'all_price',
          chinese_desc: '合计',
        },
        {
          code: 'payPrice',
          chinese_desc: '付款',
        },
        {
          code: 'check_type',
          chinese_desc: '支付方式',
        },
        {
          code: 'link_num',
          chinese_desc: '联单号',
        },
      ],
      collectionTabelTitel: [],
      unCollectionAndHouse: [],
      handoverSalesTotal: [],
      salesTabelTitel: [],
      statisticsData: [],
      cpList: [],
      cpTotal: {
        quantity: 0,
        price: 0,
        discount: 0,
        tax: 0,
        server_price: 0,
        discount_price: 0,
        all_price: 0,
      },
      statisticsSum: {
        people_count: 0,
        avgPeoplePrice: 0,
        orderCount: 0,
        avgOrderPrice: 0,
        billCount: 0,
      },
      reportDateTotal: [],
      payTypeTotal: [],
      reportDateTotalSum: 0,
      payTypeTotalSum: 0,
    };
  },
  created() {
    // this.getListMap()
    // this.getoutlets()
    // this.getNowFormatDate()
  },
  computed: {
    sumsCollection: function () {
      let sums = [];
      sums[this.collectionTabelTitel.length - 1] = undefined;
      this.collectionTabelTitel.map((item, index) => {
        this.unCollectionAndHouse.map(sItem => {
          sItem[item.productCode] = sItem[item.productCode] ? sItem[item.productCode] : 0;
          if (typeof sItem[item.productCode] == 'number') {
            if (!sums[index]) {
              sums[index] = 0;
            }
            sums[index] += sItem[item.productCode] ? sItem[item.productCode] : 0;
          }
        });
      });
      if (this.collectionTabelTitel.length) {
        sums[0] = '合计';
      }
      return sums;
    },
    sumsSalesTotal: function () {
      let sums = [];
      sums[this.salesTabelTitel.length - 1] = undefined;
      this.salesTabelTitel.map((item, index) => {
        this.handoverSalesTotal.map(sItem => {
          sItem[item.code] = sItem[item.code] ? sItem[item.code] : 0;
          if (typeof sItem[item.code] == 'number') {
            if (!sums[index]) {
              sums[index] = 0;
            }
            sums[index] += sItem[item.code] ? sItem[item.code] : 0;
          }
        });
      });
      if (this.salesTabelTitel.length) {
        sums[0] = '合计';
      }
      return sums;
    },
    sumsTotal: function () {
      let sums = [];
      sums[this.tabelTitel.length - 1] = undefined;
      this.tabelTitel.map((item, index) => {
        console.log(this.tabelTitel);
        this.tabelList.map(sItem => {
          if (item.code == 'people_count') {
            if (!sums[index]) {
              sums[index] = 0;
            }
            if (sItem[item.code]) {
              sums[index] = Number(sums[index]) + Number(sItem[item.code]);
            }
            sums[index] = sums[index] + '';
          } else {
            if (item.code != 'check_type' && item.code != 'link_num') {
              sItem[item.code] = sItem[item.code] ? sItem[item.code] : 0;
            }
            if (typeof sItem[item.code] == 'number') {
              if (!sums[index]) {
                sums[index] = 0;
              }
              sums[index] += sItem[item.code] ? sItem[item.code] : 0;
            }
          }
        });
      });
      if (this.tabelTitel.length) {
        sums[0] = '合计';
      }
      return sums;
    },
  },
  methods: {
    getListMap() {
      let url = this.api.getListMap,
        methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        console.log(res);
        this.ghvalueList = res.data.data;
      });
    },
    getoutlets() {
      let url = this.api.getoutlets,
        methods = 'get',
        data = {
          posCode: localStorage.getItem('posCode'),
        };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        console.log(res);
        this.yydvalueList = res.data.data;
      });
    },
    checkNav(v, i) {
      this.navCurrent = i;
      if ([10, 11].includes(i)) {
        this.$bus.$emit('clearCorpName');
      }
    },
    // 当天时间
    // getNowFormatDate() {
    //   var date = new Date();
    //   var seperator1 = "-";
    //   var year = date.getFullYear();
    //   var month = date.getMonth() + 1;
    //   var strDate = date.getDate();
    //   if (month >= 1 && month <= 9) {
    //     month = "0" + month;
    //   }
    //   if (strDate >= 0 && strDate <= 9) {
    //     strDate = "0" + strDate;
    //   }
    //   this.timevalue1 = year + seperator1 + month + seperator1 + strDate;
    //   console.log(this.timevalue1);
    //   this.value1 = this.timevalue1
    //   this.value2 = this.timevalue1
    //   // 昨天时间
    //   var day1 = new Date();
    //   day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
    //   var ddd = day1.getDate()
    //   var mmm = (day1.getMonth() + 1)
    //   if (mmm >= 1 && mmm <= 9) {
    //     mmm = "0" + mmm;
    //   }
    //   if (ddd >= 0 && ddd <= 9) {
    //     ddd = "0" + ddd;
    //   }
    //   this.timevalue2 = day1.getFullYear() + "-" + mmm + "-" + ddd;

    // },
    // todayOrhistory(v, i) {
    //   console.log(v);

    //   if (v == '本日') {
    //     this.value1 = this.timevalue1
    //     this.value2 = this.timevalue1
    //   } else {
    //     this.value1 = this.timevalue2
    //     this.value2 = this.timevalue2
    //   }
    //   this.searchData()
    //   this.currentTitle = i
    // },
    // printClick() {
    //   let {
    //     href
    //   } = this.$router.resolve({
    //     path: "/print",
    //     query: {

    //     },
    //   });
    //   window.open(href, "_blank");
    // }
  },
};
</script>

<style lang="scss" scoped>
.reportForm {
  width: 100%;
  min-height: calc(100vh - 90px);
  height: 100%;
  background: #fff;
  // border-radius: 20px;
  display: flex;
  overflow: hidden;

  .leftNav {
    width: 160px;
    height: 100%;
    border-right: 1px solid #eaeaea;

    .title {
      width: 100%;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0099ff;
      border-bottom: 1px solid #eaeaea;
    }

    .nav {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      .navItem {
        width: 100%;
        height: 66px;
        text-align: center;
        line-height: 66px;
        color: #666;
        cursor: pointer;
      }

      .navcheck {
        color: #fff;
        background: #0099ff;
      }
    }
  }

  .rightMain {
    width: calc(100% - 160px);
    flex: 1;

    // max-height: 1000px;
    .rightTitle {
      border-bottom: 1px solid #eaeaea;
      display: flex;
      // height: 66px;
      width: 100%;
      align-items: center;
      // padding: 0 10px 0 30px;
      justify-content: space-between;

      .Tool {
        display: flex;

        .titleItem {
          width: 130px;
          height: 40px;
          border-radius: 33px;
          background: #fff;
          text-align: center;
          cursor: pointer;
          line-height: 40px;
          margin-right: 10px;
        }

        .titleItemCurrent {
          background: #0099ff;
          color: #fff;
        }
      }

      .FunctionalityBtn {
        display: flex;

        .feffBtn {
          width: 120px;
          height: 40px;
          background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
          box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
          border-radius: 38px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          line-height: 40px;
          margin: 0 5px;
        }

        .blueBtn {
          width: 70px;
          height: 40px;
          background: #0099ff;
          box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
          margin: 0 5px;
          border-radius: 30px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          line-height: 40px;
        }
      }
    }
  }
}

.rightContent /deep/ .el-card__body {
  padding: 0 20px 20px 20px;
}
</style>
